import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import { formatarMilhar } from '../../../utils/formatarMilhar';

export default function SelectPacote(props) {
    const [spinAtivo, setSpinAtivo] = useState(false);
    const [lsPacote, setLsPacote] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handlePacote(codigo, quantidade, valor){
        props.setCdPacote(codigo)
        props.setQuantidadePacote(quantidade)
        props.setValorPacote(valor)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectPedido(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderPacote(){
            const {data} = await api_gateway.get('/m1/consultar/sms_pacote');
            if(data.dados.length > 0){
                let objetoPacote = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.ID_PACOTE}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handlePacote(item.ID_PACOTE, item.QUANTIDADE_SMS, item.VALOR_PACOTE) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label campo-select-pacote-sms nao-selecionavel">{formatarMilhar(item.QUANTIDADE_SMS)} SMS</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsPacote(objetoPacote)
            }else{
                let objetoPacote = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsPacote(objetoPacote)
            }
            setSpinAtivo(false)
        }
        renderPacote()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectPedido(false)}>
                <div className="fonte-cor-1 label-campo">{props.quantidadePacote}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsPacote}
                </ul>
            </div>
        </Form>
    )
}